'use strict';

/**
 * NotebookNoteEditor -- the rich markdown editor (pict-section-markdowneditor) hosted in the
 * notebook's Notes tab. Same editor as the Docs Lake and the entity-form description field, just
 * sized for the narrow left drawer (preview off by default; the user can toggle it on per-segment).
 *
 * It mounts into #PS-Notebook-Note-MDE, bound to AppData.NotebookNoteEditor.Segments. The host
 * (PictView-Notebook) seeds the selected note's content into that segment array, re-mounts the
 * editor after each panel render (PictView-DocEditor pattern: destroy -> render -> marshalToView),
 * and reads the edited markdown back with getAllContent('\n\n') when the user clicks Save.
 *
 * Saving is an explicit button (the host reads getAllContent), so onContentChange stays the base
 * no-op. onImageUpload is overridden so a pasted / dragged / picked image is stored in Parime owned
 * by the note (OwnerType 'Note', IDOwner = the note's id) instead of inlined as a base64 data URI.
 */

const libMarkdownEditor = require('pict-section-markdowneditor');

function buildConfiguration()
{
	let tmpConfig = JSON.parse(JSON.stringify(libMarkdownEditor.default_configuration));
	tmpConfig.ViewIdentifier = 'Plansheet-Notebook-NoteEditor';
	tmpConfig.DefaultDestinationAddress = '#PS-Notebook-Note-MDE';
	tmpConfig.TargetElementAddress = '#PS-Notebook-Note-MDE';
	tmpConfig.ContentDataAddress = 'AppData.NotebookNoteEditor.Segments';
	tmpConfig.DefaultPreviewMode = 'off';
	tmpConfig.EnableRichPreview = true;
	tmpConfig.AutoRender = false;

	if (Array.isArray(tmpConfig.Renderables))
	{
		for (let i = 0; i < tmpConfig.Renderables.length; i++)
		{
			tmpConfig.Renderables[i].DestinationAddress = '#PS-Notebook-Note-MDE';
		}
	}

	return tmpConfig;
}

class PictViewNotebookNoteEditor extends libMarkdownEditor
{
	_host() { return this.pict.views['Plansheet-Notebook']; }

	_ownerContext()
	{
		let tmpHost = this._host();
		return (tmpHost && typeof tmpHost.noteImageOwnerContext === 'function') ? tmpHost.noteImageOwnerContext() : { OwnerType: 'Note', IDOwner: 0 };
	}

	/**
	 * Pasted / dragged / picked image -> upload to Parime owned by the open note, and insert the blob
	 * URL. Returning true = async handling; returning false falls back to the base64 embed (only if the
	 * note has no id yet, which should not happen since the editor only opens on a saved note).
	 */
	onImageUpload(pFile, pSegmentIndex, fCallback)
	{
		let tmpOwner = this._ownerContext();
		if (!tmpOwner.IDOwner || !this.pict.providers.MediaAPI) { return false; }
		// Private: true -> owned by this user (Media.IDUser), so a note's images are as private as the
		// note. They also surface in the notebook's Gallery tab (the personal "user gallery").
		this.pict.providers.MediaAPI.upload(tmpOwner.OwnerType, tmpOwner.IDOwner, pFile, { Private: true })
			.then((pRow) => fCallback(null, this.pict.providers.MediaAPI.blobURL(pRow.IDMedia)))
			.catch((pErr) => fCallback(pErr.message || String(pErr)));
		return true;
	}
}

module.exports = PictViewNotebookNoteEditor;
module.exports.default_configuration = buildConfiguration();
